import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import OCRComponent from "@/components/ocr_component/OCRComponent.vue";
import FacialBiometricsComponent from './facial_biometrics_component/FacialBiometricsComponent.vue';

export default {
  name: 'AlternativeLivenessVerification',
  mixins: [MAIN_CONTROLLER],
  components: {
    BreadCrumb,
    ClientLogo,
    OCRComponent,
    FacialBiometricsComponent
  },
  data() {
    return {
      current_step: 'liveness',
      document_list: [],
      transaction_id: null,
      submitting_data: false,
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    }
  },
  methods: {
    handleScanStarted() {
      // Scroll to top with smooth animation
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      
      // Also scroll document elements smoothly
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Use setTimeout to ensure DOM is ready, then hide overflow
      setTimeout(() => {
        // Find and hide overflow on the container-fluid
        const containers = document.querySelectorAll('.container-fluid');
        containers.forEach(container => {
          container.style.overflow = 'hidden';
          container.scrollTop = 0;
        });
        
        // Hide on body and html
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }, 600); // Wait for smooth scroll to complete
    },
    set_current_ocr() {
      this.current_step = 'ocr';
    },
    handleDocumentProcessed(data) {
      if (data.documentList) {
        this.document_list = data.documentList;
      }
      else if (data.transactionId) {
        this.transaction_id = data.transactionId;
      }
      this.submitting_data = true;
      this.document_verification();
    },
    document_verification() {
      const TOKEN = localStorage.getItem("token");
      const SAFPS_URL = `${API_BASE_URL}/verify_api/personnel_verification/facial_comparison_ocr_service/`;
      var form_data = {
        workflow_id: this.workflow_id,
        liveness_photo: this.photo
      };

      if (this.document_list) {
         form_data['document_list'] = this.document_list;
      }
      else if (this.transaction_id) {
        form_data['transaction_id'] = this.transaction_id;
      }
      else {
        Swal.fire({
          icon: "error",
          text: "No document or transaction ID found. Please try again.",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
        return;
      }
      $.ajax({
        url: SAFPS_URL,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(form_data),
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          const status_message = response.status;
          if (status_message === "success") {
            var response_data = response.data;
            if (response_data.result) {
              this.fetch_current_service();
            } else {
              Swal.fire({
                icon: "error",
                text: "Could not verify liveness, please try again",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                allowOutsideClick: false
              }).then(() => {
                  window.location.reload();
              });
            }
          } else if (status_message === "error") {
            Swal.fire({
              icon: "error",
              text: "Could not read document, please provide a valid document and try again",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              text: "Our service is currently unavailable. Please try again later",
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error retrieving data";
          if (error.responseJSON) {
            error_message = error.responseJSON.id_number[0];
            Swal.fire({
              icon: "error",
              text: error_message
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              text: error_message
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.reload();
              }
            });
          }
        },
      });
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
  },
};
